import useSWR from 'swr';
import axiosInstance from '@/api/axiosInstance';

interface CategoryStat {
  categoryId: number | null;
  categoryName: string;
  total: number;
  count: number;
  // 관리자가 등록한 카테고리 메모. 헌금 통계에만 내려오고, 없으면 null.
  note?: string | null;
}

interface MonthData {
  month: number;
  income: { total: number; categories: CategoryStat[] };
  expense: { total: number; categories: CategoryStat[] };
}

interface OfferingStats {
  year: number;
  monthly: MonthData[];
  currentBalance: number;
  balanceDate: string | null;
}

const fetcher = (url: string) => axiosInstance.get(url).then(res => res.data);

// 헌금 통계 데이터 조회 훅
export default function useOfferingStats(year: number) {
  const { data, error, isLoading } = useSWR<OfferingStats>(
    `/statistics/offerings?year=${year}`,
    fetcher,
    { revalidateOnFocus: false },
  );

  return { data, error, isLoading };
}

// 울타리기금 통계 데이터 조회 훅
export function useFundStats(year: number) {
  const { data, error, isLoading } = useSWR<OfferingStats>(
    `/statistics/fund?year=${year}`,
    fetcher,
    { revalidateOnFocus: false },
  );

  return { data, error, isLoading };
}
